import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { emailRegex, FormState } from '@opu/utils';
import AxiosInstance from '../../../helpers/AxiosInstance';
import { useTranslation } from 'react-i18next';
import FormData from 'form-data';
import { useHistory } from 'react-router-dom';

const useForm = () => {
  const history = useHistory();
  const { t, i18n } = useTranslation();

  const [loading, setLoading] = useState(false);

  const back = () => {
    history.goBack();
  };

  const createAuthor = () => {
    const formData = new FormData();
    formData.append('name', formState.inputValues.name);
    formData.append('display', formState.inputValues.display);
    formData.append('image', formState.inputValues.image);
    setLoading(true);

    AxiosInstance({
      method: 'post',
      url: '/author',
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then((response) => {
        Swal.fire(t('author.SUCCESS_CREATE_AUTHOR'), '', 'success');
        setLoading(false);
        resetFormState();
      })
      .catch((error) => {
        if (error.status === 400) {
          handleErrorsServer(error.data.message);
        } else Swal.fire(t('author.ERROR_CREATE_AUTHOR'), '', 'error');
        setLoading(false);
      });
  };

  const inputValues = {
    name: { value: '', validate: { required: true } },
    display: { value: false, validate: { required: true } },
    image: { value: '', validate: { required: false } },
  };

  const { formState, inputChangeHandler, submitHandler, resetFormState, field, handleErrorsServer } = FormState(
    inputValues,
    createAuthor
  );

  return {
    formState,
    submitHandler,
    resetFormState,
    inputChangeHandler,
    loading,
    field,
    back,
  };
};

export default useForm;
